import { BusinessJobWithAppointments } from 'models';
import { client } from 'shared';

export function getUpcomingShifts(providerUserId: number): Promise<BusinessJobWithAppointments[]> {
    return client(`api/admin-jobs/upcoming-provider-shifts/?user_id=${providerUserId}`);
}
